module.exports = __webpack_public_path__ + "static/media/tennis.a2767af2.svg";